import { RootState } from "../store";

export const all = (state: RootState) => state.gameReducer;

export const games = (state: RootState) => all(state).games;
export const providers = (state: RootState) => all(state).providers;
export const filter = (state: RootState) => all(state).filter;
export const category = (state: RootState) => all(state).category;
export const lastPage = (state: RootState) => all(state).lastPage;
export const gameUrl = (state: RootState) => all(state).gameUrl;
export const favorite = (state: RootState) => all(state).favorite;
export const history = (state: RootState) => all(state).history;
export const newHistory = (state: RootState) => all(state).newHistory;
export const currentGame = (state: RootState) => all(state).currentGame;
export const currentAliasGame = (state: RootState) =>
  all(state).currentAliasGame;
export const searchGames = (state: RootState) => all(state).searchGames;
export const searchResult = (state: RootState) => all(state).searchResult;
export const isFilterReseted = (state: RootState) => all(state).isFilterReseted;
